import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { getPracticeNotesQR } from "../../../services/mentorServices/PracticeNotesServices";

const DailyPracticeNotesCard = ({ day }) => {
  const [qrCode, setQrCode] = useState(null);
  const [qrLoading, setQrLoading] = useState(false);
  const [openQrDialog, setOpenQrDialog] = useState(false); 

  const handleViewQR = () => {
    setOpenQrDialog(true); 
    setQrLoading(true);
  };

  useEffect(() => {
    if (openQrDialog) {
      const fetchQR = async () => {
        try {
          const response = await getPracticeNotesQR(day.daily_note_id);
          if (response && response.data) {
            const blob = new Blob([response.data], { type: "image/png" });
            const url = window.URL.createObjectURL(blob);
            setQrCode(url);
          } else {
            throw new Error("Invalid response data");
          }
        } catch (error) {
          toast.error(error?.response?.data.message || error?.message || "Failed to fetch QR code");
          setQrCode(null);
        } finally {
          setQrLoading(false);
        }
      };
      fetchQR();
    }
  }, [openQrDialog, day.daily_note_id]);

  const handleDownloadQR = async () => {
    try {
      const response = await getPracticeNotesQR(day.daily_note_id);
      if (response && response.data) {
        const blob = new Blob([response.data], { type: "image/png" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `PracticeNotes-${day.makerplan_name?.trim()}-${day.module_name?.trim()}-${day.topic_name?.trim()}-${day.note_name?.trim()}.png`;
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success("QR code downloaded successfully");
      } else {
        throw new Error("Invalid response data");
      }
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || "Failed to download QR code");
    }
  };

  const handleQrDialogClose = () => {
    if (qrCode) {
      window.URL.revokeObjectURL(qrCode);
      setQrCode(null);
    }
    setOpenQrDialog(false);
    setQrLoading(false);
  };

  useEffect(() => {
    return () => {
      if (qrCode) {
        window.URL.revokeObjectURL(qrCode);
      }
    };
  }, [qrCode]);

  return (
    <Paper elevation={3} sx={{ padding: 2, maxWidth: 500, margin: "auto", width:"90% !important" }}>
      {/* <Typography variant="h6" fontWeight="bold" gutterBottom>
        Daily Practice Note: {day.note_name} - {day.topic_name || "No Topic"}
      </Typography> */}

      <Grid container spacing={1} display="flex" flexDirection={"column"}>
        {[
          { label: "Maker Plan", value: day.makerplan_name || "No Maker Plan" },
          { label: "Module", value: day.module_name || "No Module" },
          { label: "Topic", value: day.topic_name || "No Topic" },
          // { label: "Note Code", value: day.note_code || "N/A" },
          // { label: "Total Learners", value: day.total_learners || 0 },
          // { label: "Learners Started", value: day.total_learners_started || 0 },
          // { label: "Learners Not Started", value: day.learners_not_started || 0 },
          { label: "PDF Path", value: day.topic_pdf_path ? (
            <a href={day.topic_pdf_path} target="_blank" rel="noopener noreferrer">
              View PDF
            </a>
          ) : "N/A" },
        ].map(({ label, value }) => (
          <Grid item xs={12} key={label} display="flex" justifyContent="space-between">
            <Typography variant="body1" fontWeight="bold">
              {label}:
            </Typography>
            <Typography variant="body1">{value}</Typography>
          </Grid>
        ))}
      </Grid>

      <Box mt={3} display="flex" justifyContent="space-around">
        <Button variant="contained" color="primary" size="medium" onClick={handleViewQR}>
          View QR
        </Button>
        <Button variant="contained" color="primary" size="medium" onClick={handleDownloadQR}>
          Download QR
        </Button>
      </Box>


      <Dialog open={openQrDialog} onClose={handleQrDialogClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: "bold" }}>
          QR Code for {day.note_name} - {day.topic_name || "No Topic"}
        </DialogTitle>
        <DialogContent sx={{ display: "flex", justifyContent: "center", p: 2 }}>
          {qrLoading ? (
            <CircularProgress />
          ) : qrCode ? (
            <img src={qrCode} alt="QR Code" style={{ width: "100%", maxWidth: 300 }} />
          ) : (
            <Typography>No QR code available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleQrDialogClose} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default DailyPracticeNotesCard;